module.exports = __webpack_public_path__ + "static/media/hilda_s_digs_by_corriger-dbohpke.8d4961a4.png";